import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getLocalizedAttrValue, sanitizeStringForUrl, getAttrValue, isString } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@bloomreach/spa-sdk';
import { getUrl } from '../../../../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../../../utils/http-client.js';

function createSubCategoryBreadcrumb(categoryRoute, product, productType, locale, page) {
    var ref;
    var ref1;
    // Get the path of the route (in BR preview you also get some querystring that we don't need to create the subcategory link)
    const categoryRoutePath = (ref1 = (ref = categoryRoute === null || categoryRoute === void 0 ? void 0 : categoryRoute.split('?')) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : '';
    // If the productType is of lenses we will use the replacementFrequency to create the url
    if (productType && CommerceToolsApi.isLenses(productType)) {
        const replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
        return replacementFrequency != '' ? {
            name: replacementFrequency,
            url: getUrl(`${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(replacementFrequency))}`, page)
        } : null;
    }
    // If the productType is solutions we will use the contactLensCareType to create the url
    if (productType && CommerceToolsApi.isSolutions(productType)) {
        const contactLensCareType = product && getLocalizedAttrValue(product.masterVariant, 'contactLensCareType', locale) || '';
        return contactLensCareType ? {
            name: contactLensCareType,
            url: `${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(contactLensCareType))}`
        } : null;
    }
    const brand = getAttrValue(product.masterVariant, 'brand');
    return isString(brand) && brand !== '' ? {
        name: String(brand),
        url: getUrl(`${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(brand))}`, page)
    } : null;
}

export { createSubCategoryBreadcrumb };
//# sourceMappingURL=create-subcategory-breadcrumb.js.map
